import Cookie from 'js-cookie';

export const setCookieByUserData = async (res_data) => {
  const headers = res_data.data.headers;

  Cookie.set('currentUser', JSON.stringify({ data: res_data }), { domain: process.env.DOMAIN, expires: 2, secure: process.env.SECURE });
  Cookie.set('client', headers.client, { domain: process.env.DOMAIN, expires: 2, secure: process.env.SECURE });
  Cookie.set('uid', headers.uid, { domain: process.env.DOMAIN, expires: 2, secure: process.env.SECURE });
  Cookie.set('access-token', headers['access-token'], { domain: process.env.DOMAIN, expires: 2, secure: process.env.SECURE });
};

export const setCookieByProfileData = async (res_data) => {
  Cookie.set('my_profile', JSON.stringify({ isFetching: false, data: res_data, error: null, msg: null }));
};

export const removeAllCookie = () => {
  Cookie.remove('access-token', { domain: process.env.DOMAIN });
  Cookie.remove('user-id', { domain: process.env.DOMAIN });
  Cookie.remove('redirectUrl');
};

export const setCurrentUserToCookie = (res_data, ctx) => {
  const user = JSON.stringify({
    isFetching: false,
    data: res_data,
    error: null,
    msg: null
  });

  if (ctx) {
    ctx.req.cookies.currentUser = user;
    ctx.res.cookie('currentUser', user);
  } else {
    Cookie.set('currentUser', user);
  }
};

export const setReferralCodeCookie = (code, ctx) => {
  if (ctx) {
    ctx.req.cookies.referralCode = code;
    ctx.res.cookie('referralCode', code);
  } else {
    Cookie.set('referralCode', code, { domain: process.env.DOMAIN, expires: 30, secure: process.env.SECURE });
  }
};

export const setJobIdCookie = (id, ctx) => {
  if (ctx) {
    ctx.req.cookies.id = id;
    ctx.res.cookie('id', id);
  } else {
    Cookie.set('id', id, { domain: process.env.DOMAIN, expires: 30, secure: process.env.SECURE });
  }
};

export const setPublishCookie = (published, ctx) => {
  if (ctx) {
    ctx.req.cookies.published = published;
    ctx.res.cookie('published', published);
  } else {
    Cookie.set('published', published, { domain: process.env.DOMAIN, expires: 30, secure: process.env.SECURE });
  }
};

export const removeReferralCodeCookie = () => {
  Cookie.remove('referralCode', { domain: process.env.DOMAIN });
  Cookie.remove('id', { domain: process.env.DOMAIN });
  Cookie.remove('published', { domain: process.env.DOMAIN });
};

export const setRedirectUrlCookie = (url) => {
  Cookie.set('redirectUrl', url);
};

export const removeRedirectUrlCookie = () => {
  Cookie.remove('redirectUrl');
};
